import React from 'react'
import { MuiTextfield } from 'material-ui-elements'
import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const {
  helpers: { keepInLength, calculatePeriod, calculateFlag, getUserProfileLocal }
} = core

const {
  decision,
  theirRole,
  visitType,
  judgement,
  themeNoL1,
  themeNoL2,
  themeDescriptionL1,
  themeDescriptionL2,
  centreActionStatus
} = commonConfigValues

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const valueTable = {}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      // 'register.ui',
      'register.sector',
      'register.organizationName',
      'register.name',
      'monitor.visitType',
      'monitor.visitDate',
      // 'LINE 1 THEME',
      // 'LINE 2 THEME',
      'action.actionsAgreed',
      'action.originalDueDate',
      'action.revisedDueDate',
      'action.status',
      'action.validFrom',
      'action.flag'
    ]
  }
]

export const defaultSorting = [
  { columnName: 'monitor.visitDate', direction: 'asc' }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.ui',
    title: 'Centre UI',
    minSpace: 'Centre UI ',
    getCellValue: row => row['id'],
    formField: true
  },
  {
    name: 'register.sector',
    title: 'Centre Sector',
    minSpace: 'Centre Sector ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'register.organisationName',
    title: 'Centre Organisation Name',
    minSpace: 'Centre Organisation ',
    formField: true,
    hidden: getUserProfileLocal().role === 'Level 1'
  },
  {
    name: 'register.name',
    title: 'Centre / Unit Name',
    // hidden: true,
    minSpace: 'Centre / Unit ',
    formField: true
  },

  {
    name: 'monitor.hiqaCenter',
    title: 'Monitoring Centre ID No.',
    formField: true,
    minSpace: 'Monitoring Centre ID No. '
  },
  {
    name: 'monitor.hiqaInspection',
    title: 'Monitoring Inspection ID No.',
    formField: true,
    minSpace: 'Monitoring Inspection ID No. '
  },

  {
    name: 'monitor.visitType',
    title: 'Visit Type ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(visitType, ['id', parseInt(row[`monitor.visitType`], 10)])
        ? _.find(visitType, ['id', parseInt(row[`monitor.visitType`], 10)])
            .label
        : row[`monitor.visitType`],
    options: 'visitType',
    filterField: true,
    minSpace: 'Visit Type '
  },
  {
    name: 'monitor.visitDate',
    title: 'Visit Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Visit '
  },
  {
    name: 'monitor.draftDate',
    title: 'Final Draft Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Final Draft D '
  },
  {
    name: 'monitor.draftTimeframe',
    title: 'Visit / Final Draft Timeframe',
    formField: true,
    getCellValue: row =>
      calculatePeriod(row[`monitor.visitDate`], row[`monitor.draftDate`]),
    // filterField: true,
    minSpace: 'Draft Timeframe / '
  },
  {
    name: 'monitor.monitorName',
    title: 'Monitor Name(s)',
    formField: true,
    // filterField: true,
    minSpace: 'Monitor Name(s) '
  },
  {
    name: 'monitor.monitorRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`monitor.monitorRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`monitor.monitorRole`], 10)])
            .label
        : row[`monitor.monitorRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'monitor.themeNoL1',
    title: 'Monitored Standard / Theme ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeNoL1, ['id', parseInt(row[`monitor.themeNoL1`], 10)])
        ? _.find(themeNoL1, ['id', parseInt(row[`monitor.themeNoL1`], 10)])
            .label
        : row[`monitor.themeNoL1`],
    options: 'themeNoL1',
    filterField: true,
    minSpace: 'Monitored Standard / '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'monitor.themeDescriptionL1',
    title: 'Monitored Standard / Theme Description',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeDescriptionL1, [
        'id',
        parseInt(row[`monitor.themeDescriptionL1`], 10)
      ])
        ? _.find(themeDescriptionL1, [
            'id',
            parseInt(row[`monitor.themeDescriptionL1`], 10)
          ]).label
        : row[`monitor.themeDescriptionL1`],
    options: 'themeDescriptionL1',
    filterField: true,
    minSpace: 'Monitored Standard / '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'monitor.themeNoL2',
    title: 'Monitored Standard / Theme ',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeNoL2, ['id', parseInt(row[`monitor.themeNoL2`], 10)])
        ? _.find(themeNoL2, ['id', parseInt(row[`monitor.themeNoL2`], 10)])
            .label
        : row[`monitor.themeNoL2`],
    options: 'themeNoL2',
    filterField: true,
    minSpace: 'Monitored Standard / '
  },
  {
    //FUNCTION TO SELECT THEME BASED ON CHILD STATUS
    name: 'monitor.themeDescriptionL2',
    title: 'Monitored Standard / Theme Description',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(themeDescriptionL2, [
        'id',
        parseInt(row[`monitor.themeDescriptionL2`], 10)
      ])
        ? _.find(themeDescriptionL2, [
            'id',
            parseInt(row[`monitor.themeDescriptionL2`], 10)
          ]).label
        : row[`monitor.themeDescriptionL2`],
    options: 'themeDescriptionL2',
    filterField: true,
    minSpace: 'Monitored Standard / '
  },
  {
    name: 'monitor.judgement',
    title: 'Monitor Findings',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(judgement, ['id', parseInt(row[`monitor.judgement`], 10)])
        ? _.find(judgement, ['id', parseInt(row[`monitor.judgement`], 10)])
            .label
        : row[`monitor.judgement`],
    options: 'judgement',
    filterField: true,
    minSpace: 'Monitor Findings '
  },

  {
    name: 'action.actionsRequired',
    title: 'Actions Required',
    formField: true,
    // filterField: true,
    minSpace: 'Actions Required '
  },
  {
    name: 'action.actionsAgreed',
    title: 'Agreed Actions',
    formField: true,
    // filterField: true,
    minSpace: 'Agreed Actions '
  },
  {
    name: 'action.responsiblePeople',
    title: 'Agreed Actions',
    formField: true,
    // filterField: true,
    minSpace: 'Agreed Actions '
  },
  {
    name: 'action.responsibleRole',
    title: 'Their Role',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`action.responsibleRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`action.responsibleRole`], 10)])
            .label
        : row[`action.responsibleRole`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'action.originalDueDate',
    title: 'Original Action Due Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Original Action '
  },
  {
    name: 'action.revisedDueDate',
    title: 'Revised Action Due Date (I/A)',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Revised Action '
  },
  {
    name: 'action.informedChange',
    title: 'HIQA Informed of Change in Due Date?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`action.informedChange`], 10)])
        ? _.find(decision, ['id', parseInt(row[`action.informedChange`], 10)])
            .label
        : row[`action.informedChange`],
    options: 'decision',
    filterField: true,
    minSpace: 'HIQA Informed of Change in '
  },
  {
    name: 'action.status',
    title: 'Action Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(centreActionStatus, ['id', parseInt(row[`action.status`], 10)])
        ? _.find(centreActionStatus, ['id', parseInt(row[`action.status`], 10)])
            .label
        : row[`action.status`],
    options: 'centreActionStatus',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'action.validFrom',
    title: 'Action Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Action Status '
  },
  {
    name: 'action.flag',
    title: 'Agreed Action Flags',
    formField: true,
    filterField: true,
    minSpace: 'Agreed Action Flags '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues,
  activeFormName
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'monitor',
      historyName: 'monitorHistory',
      label: 'Centre',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Centre Entry',
          // hint: 'Select Centre Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const label = `${o.name} (register: ${o.id})`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'mon',
      activeName: 'monitor',
      historyName: 'monitorHistory',
      label: 'Monitoring',
      icon: 'note',
      fields: [
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.hiqaCenter',
            label: 'Monitoring Centre ID No.',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            // hint: 'Enter ID',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 10)
              return val.toUpperCase()
            },
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.hiqaInspection',
            label: 'Monitoring Inspection ID No.',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            // hint: 'Enter ID',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 10)
              return val.toUpperCase()
            },
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.visitType',
            label: 'Visit Type',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            // hint: 'Select Visit Type',
            required: showAsterix,
            options: availableValues.visitType.map(o => {
              return { value: o.id, label: o.label }
            }),
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.visitDate',
            label: 'Visit Date',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            onChange: (e, v) => {
              change(
                formName,
                'monitor.draftTimeframe',
                calculatePeriod(v, _.get(formValues, 'monitor.draftDate'))
              )
            }
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.draftDate',
            label: 'Final Draft Date',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            onChange: (e, v) => {
              change(
                formName,
                'monitor.draftTimeframe',
                calculatePeriod(v, _.get(formValues, 'monitor.visitDate'))
              )
            }
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            component: v => (
              <MuiTextfield
                style={styles.fieldText}
                disabled={true}
                input={{
                  floatingLabelStyle: { ...styles.floatingLabel }
                }}
                value={calculatePeriod(
                  formValues &&
                    formValues.monitor &&
                    formValues.monitor.visitDate,
                  formValues &&
                    formValues.monitor &&
                    formValues.monitor.draftDate
                )}
                label={'Visit / Final Draft Timeframe'}
              />
            ),
            name: 'monitor.draftTimeframe',
            label: 'Visit / Final Draft Timeframe',
            disabled: true
          }
        ],
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.monitorName',
            label: 'Monitor Name(s)',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            // hint: 'Enter Name',
            required: showAsterix,
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'monitor.monitorRole',
            label: 'Their Role(s)',
            disabled: !add && (disabled || activeFormName !== 'mon'),
            // hint: 'Select Their Role',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'mon' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ]
      ]
    },
    {
      id: 3,
      name: 'act',
      activeName: 'action',
      historyName: 'actionHistory',
      label: 'Actions',
      icon: 'note',
      fields: [
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'action.actionsRequired',
          label: 'Actions Required ',
          disabled: !add && (disabled || activeFormName !== 'act'),
          // hint: 'Enter Actions',
          required: showAsterix,
          // normalize: v => {
          //   const val = keepInLength(v, 10)
          //   return val
          // }
          validate: v =>
            activeFormName !== 'act' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'action.actionsAgreed',
          label: 'Actions Agreed ',
          disabled: !add && (disabled || activeFormName !== 'act'),
          // hint: 'Enter Actions',
          required: showAsterix,
          // normalize: v => {
          //   const val = keepInLength(v, 10)
          //   return val
          // }
          validate: v =>
            activeFormName !== 'act' && !add
              ? undefined
              : v ? undefined : 'Field is required'
        },
        [
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'action.responsible',
            label:
              'Person / People Responsible for Implementing this Action Name(s)',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Enter Responsible People',
            normalize: v => {
              const val = keepInLength(v, 50)
              return val
            },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.responsibleRole',
            label: 'Their Role(s)',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Select Their Role',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.originalDueDate',
            label: 'Original Action Due Date',
            disabled: !add && (disabled || activeFormName !== 'act'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(
                formName,
                'action.flag',
                calculateFlag(
                  (formValues &&
                    formValues.action &&
                    formValues.action.revisedDueDate) ||
                    v
                )
              )
            },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.revisedDueDate',
            label: 'Revised Action Due Date (I/A)',
            disabled: !add && (disabled || activeFormName !== 'act'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            onChange: (e, v) => {
              change(formName, 'action.flag', calculateFlag(v))
            },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.informedChange',
            label: 'HIQA Informed of Change in Due Date?',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Select Status',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.decision.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.status',
            label: 'Action Status',
            disabled: !add && (disabled || activeFormName !== 'act'),
            // hint: 'Select Status',
            required: showAsterix,
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required',
            options: availableValues.centreActionStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'action.validFrom',
            label: 'Action Status Valid at Date',
            disabled: !add && (disabled || activeFormName !== 'act'),
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v =>
              activeFormName !== 'act' && !add
                ? undefined
                : v ? undefined : 'Field is required'
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          disabled: true,
          component: v => (
            <MuiTextfield
              style={styles.fieldText}
              disabled={true}
              input={{
                floatingLabelStyle: { ...styles.floatingLabel }
              }}
              value={calculateFlag(
                (formValues &&
                  formValues.action &&
                  formValues.action.revisedDueDate) ||
                  (formValues &&
                    formValues.action &&
                    formValues.action.originalDueDate)
              )}
              label={'Agreed Action Flags'}
            />
          ),
          name: 'action.flag',
          label: 'Agreed Action Flags'
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['monitor', 'action']

export const errors = [1, 2]

export const defaultNew = {
  monitor: {
    historyId: 'new'
  },
  action: {
    historyId: 'new'
  },
  monitorHistory: [],
  actionHistory: []
}

// "inspections": [
//   {
//   "id": 1,
//   "registerId": 1,
//  "inspection": {
//    "historyId":1,
//   "inspectionDate": "2001-01-01T23:28:56.782Z",
// },
// "inspectionHistory": []
//   }
// ]



// WEBPACK FOOTER //
// ./src/centre/configs/monitoring.js